import React from 'react';
import RseeDashboardGuide from './rseeAdmin/rseeAdminDashboardGuide';
import CafeDashboardGuide from './cafeAdmin/cafeAdminDashboardGuide';
import ShowForPermission from '../../components/ShowForPermission';
import ENUMS from '../../enums';

const Dashboard = props => {
  return (
    <>
      <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_ADMIN_DASHBOARD_REPORTS}>
        <RseeDashboardGuide />
      </ShowForPermission>
      <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_CAFE_ADMIN_DASHBOARD_REPORTS}>
        <CafeDashboardGuide />
      </ShowForPermission>
    </>
  );
};

export default Dashboard;
